<ui-tile
  *ngIf="mode !== 'list'"
  [thumbnail]="item ? (item.cover | cloudUrl) : undefined"
  [url]="item ? '/' + scope + '/' + item.slug : undefined"
  [title]="item ? item.title : undefined"
>
  <div class="score" *ngIf="item">
    <div class="app-rating-tiny" *ngIf="item?.reviews.total > 0">
      <div
        class="five-pointed-star xs"
        [ngStyle]="{ '--rating': item?.reviews?.aggr_rating }"
        name="star"
      ></div>

      <div class="ratings">
        <span class="rating-sum">({{ item?.reviews.total }})</span>
        <span class="rating-q">Ø {{ item?.reviews.aggr_rating | number : '1.0-1' }}</span>
      </div>
    </div>
  </div>
  <div class="short-description" *ngIf="item">
    {{ item.short_desc }}
  </div>

  <div class="app-info-line">
    <div class="app-offer" *ngIf="item && item.price">
      <div class="app-offer-pricetags">
        <span
          class="app-offer-pricetag-before"
          *ngIf="item?.orig_price !== null && item.orig_price.gross.price > 0.0"
        >
          {{ item.orig_price.gross.price | currency : item.price.gross.currency : 'symbol' }}
        </span>

        <span class="app-offer-pricetag-default" *ngIf="item">
          {{
            item.price.gross.price <= 0.0
              ? ('filter.prices.free' | transloco)
              : (item.price.gross.price | currency : item.price.gross.currency : 'symbol')
          }}
        </span>
      </div>
      <span class="app-offer-pricetag-discount" *ngIf="item?.discount > 0.0">
        -{{ item.discount }}%
      </span>
    </div>

    <div class="app-item-badges" *ngIf="item?.platforms">
      <div class="os-badge windows" *ngIf="item?.platforms.includes('win')">
        <ion-icon color="windows" name="logo-windows"></ion-icon>
      </div>
      <div class="os-badge linux" *ngIf="item?.platforms.includes('linux')">
        <ion-icon color="tux" name="logo-tux"></ion-icon>
      </div>
      <div class="os-badge apple" *ngIf="item?.platforms.includes('mac')">
        <ion-icon color="apple" name="logo-apple"></ion-icon>
      </div>
      <div class="os-badge chrome" *ngIf="item?.platforms.includes('web')">
        <ion-icon color="chrome" name="logo-chrome"></ion-icon>
      </div>
    </div>
  </div>

  <ion-skeleton-text *ngIf="!item"></ion-skeleton-text>
  <ion-skeleton-text *ngIf="!item"></ion-skeleton-text>
  <ion-skeleton-text *ngIf="!item"></ion-skeleton-text>

  <span
    down
    *ngIf="item?.is_pre_release"
    class="app-item-badge info"
    transloco="product.prerelease"
  >
  </span>

  <div class="app-item-footer">
    <button
      class="btn btn-xxs btn-block btn-solid secondary btn-truncate"
      (click)="action.callback()"
      *ngFor="let action of actions"
    >
      <ion-icon *ngIf="action.icon" [name]="action.icon"></ion-icon> <span>{{ action.name }}</span>
    </button>
    <button
      right
      class="btn btn-xxs btn-solid btn-rounded uppercase app-item-hover-btn"
      [tooltip]="
        isOnList
          ? ('product.details.remove_from_wishlist' | transloco)
          : ('product.details.add_to_wishlist' | transloco)
      "
      placement="top"
      [ngClass]="isOnList ? 'primary' : 'secondary'"
      (click)="addToWishList($event)"
      *ngIf="item && hasActions"
    >
      <ion-icon [name]="isOnList ? 'bag-remove-outline' : 'bag-add-outline'"></ion-icon>
    </button>
  </div>
</ui-tile>

<ui-list-item
  [title]="item ? item.title : undefined"
  [thumbnail]="item ? item.cover : undefined"
  thumbnailBorderRadius="3px"
  [thumbnailWidth]="70"
  [hasActions]="true"
  [thumbnailHeight]="85"
  *ngIf="mode == 'list'"
  [url]="item ? '/' + scope + '/' + item.slug : undefined"
>
  <button
    uiListItemAction
    class="btn btn-xxs btn-solid btn-rounded uppercase app-item-hover-btn"
    [tooltip]="
      isOnList
        ? ('product.details.remove_from_wishlist' | transloco)
        : ('product.details.add_to_wishlist' | transloco)
    "
    placement="top"
    [ngClass]="isOnList ? 'primary' : 'secondary'"
    (click)="addToWishList($event)"
    *ngIf="item && hasActions"
  >
    <ion-icon [name]="isOnList ? 'bag-remove-outline' : 'bag-add-outline'"></ion-icon>
  </button>

  <div class="description" *ngIf="item && item.short_desc">
    <span>{{ item.short_desc }}</span>
  </div>
  <div class="list-item-platforms" *ngIf="item">
    <div class="app-item-badges" *ngIf="item?.platforms">
      <div class="values" *ngIf="item">
        <div class="os-badge windows" *ngIf="item?.platforms.includes('win')">
          <ion-icon color="windows" name="logo-windows"></ion-icon>
        </div>
        <div class="os-badge linux" *ngIf="item?.platforms.includes('linux')">
          <ion-icon color="tux" name="logo-tux"></ion-icon>
        </div>
        <div class="os-badge apple" *ngIf="item?.platforms.includes('mac')">
          <ion-icon color="apple" name="logo-apple"></ion-icon>
        </div>

        <ion-badge color="warning" class="ion-text-wrap" *ngIf="item?.discount > 0.0">
          -{{ item.discount }}%
        </ion-badge>
        <ion-label
          color="menu"
          class="price-before ion-text-wrap"
          *ngIf="item?.orig_price !== null && item.orig_price.gross.price > 0.0"
        >
          {{ item.orig_price.gross.price | currency : item.orig_price.gross.currency : 'symbol' }}
        </ion-label>
        <ion-label color="menu" class="price ion-text-wrap">
          {{
            item.price.gross.price === 0.0
              ? ('filter.prices.free' | transloco)
              : (item.price.gross.price | currency : item.price.gross.currency : 'symbol')
          }}</ion-label
        >
      </div>

      <div class="score" *ngIf="item">
        <div class="app-rating-tiny" *ngIf="item?.reviews.total > 0">
          <div
            class="five-pointed-star xs"
            [ngStyle]="{ '--rating': item?.reviews?.aggr_rating }"
            name="star"
          ></div>
          <div class="ratings">
            <span class="rating-sum">({{ item?.reviews?.total }})</span>
            <span class="rating-q">Ø {{ item?.reviews?.aggr_rating | number : '1.0-1' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ui-list-item>
